// extracted by mini-css-extract-plugin
export var actions = "_e5-d";
export var benefitCard = "_e5-a";
export var benefitIcon = "_e5-b";
export var benefitLabel = "_e5-c";
export var benefits = "_e5-9";
export var bodyText = "_e5-8";
export var closeButton = "_e5-2";
export var content = "_e5-3";
export var eyebrow = "_e5-4";
export var heading = "_e5-5";
export var image = "_e5-f";
export var imagePanel = "_e5-e";
export var modal = "_e5-0";
export var shell = "_e5-1";
export var title = "_e5-6";
export var titleOffer = "_e5-7";